import { useDispatch, useSelector } from 'react-redux'
import RadioGroup from '../../../../../UI/RadioGroup/RadioGroup'
import { getUUID } from '../../../../../../utility'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const SpecialRights = ({ payload }) => {
  const translations = useSelector((state) => state.translations)
  const settings = useSelector((state) => state.settings)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)

  const dispatch = useDispatch()

  const update = (key) => (value) => {
    const newState = { ...purchaseProfile, specialRights: purchaseProfile?.specialRights ? { ...purchaseProfile.specialRights, [key]: value } : { [key]: value } }
    // dispatch(setNewPurchaseProfile(newState))
    dispatch(setLocal(props.PURCHASE_PROFILE, newState))
  }

  const getValue = (key) => (purchaseProfile.specialRights?.[key] ? purchaseProfile.specialRights?.[key] : '')

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.yield-and-object-criteria.special-rights']}</div>
        <div className="values">
          {settings.getGroup(payload).map((option) => (
            <RadioGroup
              inline={true}
              key={getUUID()}
              name={translations[option.translationKey]}
              value={getValue(option.key)}
              onChange={update(option.key)}
              options={settings.getGroup('radiogroup.default.options').map((option) => ({ key: option.key, value: translations[option.translationKey] }))}
              showEmptyOption={true}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default SpecialRights
